import { Injectable } from '@angular/core';

export interface Rating {
  name: string;
  minScore: number;
  maxScore: number;
  description: string;
  color: string;
}

@Injectable({
  providedIn: 'root',
})
export class RatingService {
  private ratings: Rating[] = [
    {
      name: 'Major Non-Conformity',
      minScore: 0,
      maxScore: 2,
      color: '#dc2626', // red
      description:
        'Significant gaps exist in meeting ISO/IEC 27001:2022 requirements. Core elements of an ISMS are missing or not implemented. Immediate and substantial remediation is required before certification can be considered.',
    },
    {
      name: 'Minor Non-Conformity',
      minScore: 2,
      maxScore: 4,
      color: '#f97316', // orange
      description:
        'Some requirements are in place; however, there are notable gaps or inconsistencies. Key elements of the ISMS require improvement and formalisation to meet certification expectations.',
    },
    {
      name: 'Needs Improvement',
      minScore: 4,
      maxScore: 6,
      color: '#eab308', // yellow
      description:
        'Foundational practices are in place, but they are not yet fully formalised or consistently applied. Further development is required to align with ISO/IEC 27001:2022 requirements.',
    },
    {
      name: 'Likely Compliant',
      minScore: 6,
      maxScore: 8,
      color: '#22c55e', // green
      description:
        'Most requirements are implemented and aligned with ISO/IEC 27001:2022. Minor enhancements may be required, but the Organisation is generally well-positioned for certification readiness.',
    },
  ];

  getRating(score: number): Rating | null {
    for (const rating of this.ratings) {
      if (score >= rating.minScore && score <= rating.maxScore) {
        return rating;
      }
    }
    return this.ratings[this.ratings.length - 1];
  }

  getRatings(): Rating[] {
    return this.ratings;
  }
}